<template>
  <div class="mt-3 container__vehicle">
    <b-card class="no-border animated vehicle__card align__center" bg-variant="light">
      <b-img rounded="circle" width="75" height="75" src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSV1XkXB6DnnGJCgw1CJN0gErXojerWyJWbNnKqrp7R7Y_Xk6-eig"></b-img>
      <p class="card-text">
        <p class="h4 text-dark">{{ detailedInfo.reg_no }}</p>
      </p>
      <div class="list-group vehicle__navigations mx-auto">
        <b-nav>
          <b-nav-item @click="section = ''" :active="section == ''">Detailss</b-nav-item>
          <b-nav-item @click="section = 'activity'" :active="section == 'activity'">Activity</b-nav-item>
        </b-nav>
      </div>
    </b-card>
    <router-view></router-view>
  </div>
</template>

<script>
  export default {
    data() {
      const routes = this.$route.fullPath.split('/');
      return {
        section: routes[4] || '',
        loaded: false,
      };
    },
    created() {
      const { vehicleId } = this.$route.params;
      this.$store.commit('vehicles/SET_DETAIL_ID', vehicleId);
      this.$store.commit('SET_BREADCRUMB_ITEMS', [
        { to: '', name: 'Home' },
        { to: 'vehicles', name: 'Vehicles' },
        { to: vehicleId, name: 'Detail' },
      ]);
    },
    computed: {
      detailedInfo() {
        return this.$store.getters['vehicles/get_detail_data'];
      },
    },
    watch: {
      section(newSection) {
        const { vehicleId } = this.$route.params;
        this.$router.push(`/vehicles/${vehicleId}/${newSection}`);
      },
    },
  };
</script>

<style scoped lang="sass">
  .align__center
    text-align: center

  .vehicle__navigations
    border: none
    width: 318px

  .card-body
    padding-bottom: 0px !important

  .nav-link:hover
    border-bottom: 2px #BDBDBD solid
</style>



// WEBPACK FOOTER //
// src/views/pages/vehicle/Detail.vue